import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a441464"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "provider-chat-view p-relative p-t-16 p-b-16 d-flex flex-col flex-no-wrap justify-content-center align-items-center" }
const _hoisted_2 = { class: "chat-container d-flex flex-col flex-no-wrap p-16" }
const _hoisted_3 = { class: "d-flex flex-row align-items-center m-b-8" }
const _hoisted_4 = { class: "mha-font-body-sm" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Write To Encounter Note ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VideoViewTopControls = _resolveComponent("VideoViewTopControls")!
  const _component_PulsingIndicator = _resolveComponent("PulsingIndicator")!
  const _component_ChatView = _resolveComponent("ChatView")!
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VideoViewTopControls, {
      class: "top-controls",
      onExit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('exit')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PulsingIndicator, {
          class: _normalizeClass(["call-indicator m-r-8", _ctx.chatStateIndicatorClasses]),
          pulsing: false
        }, null, 8, ["class"]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.chattingWithMessage), 1)
      ]),
      _createVNode(_component_ChatView, {
        class: "flex-item-grow",
        onSend: _ctx.sendTextMessage,
        onSendFile: _ctx.sendDocumentMessage,
        onInput: _ctx.signalTyping,
        typing: _ctx.showTypingIndication,
        "chat-items": _ctx.chatItems,
        disabled: !_ctx.patientConnected,
        "document-chat-disabled": !_ctx.isDocumentChatAvailable
      }, null, 8, ["onSend", "onSendFile", "onInput", "typing", "chat-items", "disabled", "document-chat-disabled"])
    ]),
    (_ctx.showWriteToEncounterButton)
      ? (_openBlock(), _createBlock(_component_BaseButton, {
          key: 0,
          class: "save-to-encounter-btn m-t-32",
          color: _ctx.ButtonColor.PRIMARY,
          pattern: _ctx.ButtonColorPattern.FILL,
          disabled: !_ctx.hasChatMessages,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveToEncounterNote()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["color", "pattern", "disabled"]))
      : _createCommentVNode("", true)
  ]))
}